'use client'

import { useState, useEffect } from 'react'
import { AlertCircle, Mail } from 'lucide-react'
import ButtonComponent from '@/components/button-component';

type ErrorType = 'inactive' | '404' | '500' | 'none'

interface ErrorInfo {
  title: string
  message: string
  action: string
  icon: React.ReactNode
}

const errorMessages: Record<ErrorType, ErrorInfo> = {
  inactive: {
    title: "Cuenta no activa",
    message: "Por favor, contáctenos para activar su cuenta.",
    action: "Contactar soporte",
    icon: <Mail className="h-12 w-12 text-yellow-500" />
  },
  '404': {
    title: "404 - Página no encontrada",
    message: "Lo sentimos, la página que busca no existe.",
    action: "Ir al inicio",
    icon: <AlertCircle className="h-12 w-12 text-red-500" />
  },
  '500': {
    title: "500 - Error del servidor",
    message: "Lo sentimos, el sitio web no está disponible en este momento. Por favor, intente más tarde.",
    action: "Intentar de nuevo",
    icon: <AlertCircle className="h-12 w-12 text-red-500" />
  },
  'none': {
    title: "",
    message: "",
    action: "",
    icon: <></>
  }
}

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
}) {
  const [currentError, setCurrentError] = useState<ErrorType>('none')
  const { title, message, action, icon } = errorMessages[currentError]

  const handleAction = () => {
    switch (currentError) {
      case 'inactive':
        window.location.href = 'mailto:hello@escueladenumerologia.com'
        break
      case '404':
        window.location.href = '/'
        break
      case '500':
        window.location.reload()
        break
    }
  }

  useEffect(() => {
    if (error) {
      switch (error.message) {
        case 'Account is not active':
          setCurrentError('inactive')
          break
        case 'Not Found':
          setCurrentError('404')
          break
        default:
          setCurrentError('500')
          break
      }
    }
  }, [])

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-4">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
        <div className="mb-6 flex justify-center">
          {icon}
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">{title}</h1>
        <p className="text-gray-600 mb-6">{message}</p>
        <ButtonComponent onClick={handleAction} label={action} wFull={true} />
      </div>
    </div>
  )
}